type Props = {
  className?: string | undefined;
};

/** 抽象牙弓线稿 — 左栏装饰，opacity 由 CSS 控制 */
export function DentalArchDecor({ className }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 400 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M20 80 C80 20, 320 20, 380 80"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M60 85 C120 45, 280 45, 340 85"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        opacity="0.6"
      />
      <path
        d="M100 90 C150 65, 250 65, 300 90"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        opacity="0.4"
      />
    </svg>
  );
}

type LogoMarkProps = {
  className?: string | undefined;
};

/** 几何 Logo mark — 圆角方块 + 牙弓弧线 */
export function LogoMark({ className }: LogoMarkProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="1" y="1" width="30" height="30" rx="8" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M8 20 C12 14, 20 14, 24 20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
